"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconTwitter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconTwitter = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M8.29 20c7.547 0 11.675-6.156 11.675-11.495 0-.175 0-.349-.012-.522A8.3 8.3 0 0 0 22 5.892a8.3 8.3 0 0 1-2.356.635 4.07 4.07 0 0 0 1.804-2.234 8.3 8.3 0 0 1-2.606.98 4.153 4.153 0 0 0-5.806-.175 4.01 4.01 0 0 0-1.187 3.86 11.7 11.7 0 0 1-8.456-4.221 4.005 4.005 0 0 0 1.27 5.393A4.1 4.1 0 0 1 2.8 9.624v.052c0 1.923 1.378 3.579 3.292 3.96a4.2 4.2 0 0 1-1.852.069c.537 1.646 2.078 2.774 3.833 2.806A8.32 8.32 0 0 1 2 18.186a11.76 11.76 0 0 0 6.29 1.811" })] })));
};
exports.IconTwitter = IconTwitter;
exports.IconTwitter.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconTwitter;
